import http from '@/requests/http'

class Ivr {
  static all (params) {
    return http.post('configuration/inbound/ivr/index', params)
  }
  static async view (params) {
    return http.post('configuration/inbound/ivr/view', params)
  }
  static async update (data) {
    return http.post('configuration/inbound/ivr/update', data)
  }
  static async save (data) {
    return http.post('configuration/inbound/ivr/store', data)
  }
  static async delete (id) {
    return http.post(`configuration/inbound/ivr/delete/${id}`)
  }
}

export default Ivr
